import PropTypes from "prop-types";
import React, { useState, useMemo } from "react";
import { Container, Card, CardBody } from "reactstrap";

// PrimeReact
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// i18n
import { withTranslation } from "react-i18next";
import ClientMenu from "./detail-menu";
import { Link } from "react-router-dom";

const ClientsSubscription = props => {
  document.title = "Admin | Clients Subscription";

  // -------------------- STATE --------------------
  const [globalFilter, setGlobalFilter] = useState("");

  // -------------------- CLIENT DATA --------------------
  const clients = [
    {
      id: 1,
      buisnessName: "ABC Realty",
      address: "Toronto",
      contactName: "John Smith",
      mobilePhone: "+1 (555) 123-4567",
      phone: "+1 (555) 987-6543",
    },
    {
      id: 2,
      buisnessName: "Prime Homes",
      address: "Mississauga",
      contactName: "Sarah Lee",
      mobilePhone: "+1 (555) 888-4567",
      phone: "+1 (555) 777-6543",
    },
  ];

  const filteredClients = useMemo(() => {
    return clients.filter(client =>
      !globalFilter ||
      client.buisnessName.toLowerCase().includes(globalFilter.toLowerCase()) ||
      client.address.toLowerCase().includes(globalFilter.toLowerCase()) ||
      client.contactName.toLowerCase().includes(globalFilter.toLowerCase())
    );
  }, [clients, globalFilter]);

  // -------------------- PLAN DATA --------------------
  const plans = [
    {
      id: 1,
      type: "Monthly",
      startDate: "2025-01-01",
      amount: 99,
    },
    {
      id: 2,
      type: "Annual",
      startDate: "2025-02-15",
      amount: 999,
    },
  ];

  // -------------------- INVOICE DATA --------------------
  const invoices = [
    {
      id: 1,
      invoiceNumber: "INV-1001",
      date: "2025-01-10",
      time: "10:45 AM",
      amount: 99,
      paid: true,
    },
    {
      id: 2,
      invoiceNumber: "INV-1002",
      date: "2025-02-10",
      time: "11:30 AM",
      amount: 99,
      paid: false,
    },
  ];

  // -------------------- PAYMENT DATA --------------------
  const payments = [
    {
      id: 1,
      date: "2025-01-10",
      amount: 99,
      stripeId: "pi_3Nabcd12345",
    },
    {
      id: 2,
      date: "2025-02-10",
      amount: 99,
      stripeId: "pi_3Nxyz67890",
    },
  ];

  // -------------------- UI --------------------
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>

          <Breadcrumbs
            title={props.t("Clients")}
            breadcrumbItem={props.t("Subscription")}
          />

          <ClientMenu />

        
          {/* ================= PLAN ================= */}
          <Card className="mb-4">
            <CardBody>
              <h5 className="mb-3">Plan</h5>

              <DataTable
                value={plans}
                responsiveLayout="scroll"
                emptyMessage="No plans found"
              >
                <Column field="type" header="Type (Monthly / Annual)" />
                <Column field="startDate" header="Start Date" />
                <Column
                  field="amount"
                  header="Amount"
                  body={row => `$${row.amount}`}
                />
              </DataTable>
            </CardBody>
          </Card>

          {/* ================= INVOICES ================= */}
          <Card className="mb-4">
            <CardBody>
              <h5 className="mb-3">Invoices</h5>

              <DataTable
                value={invoices}
                responsiveLayout="scroll"
                emptyMessage="No invoices found"
              >
                <Column field="invoiceNumber" header="Invoice #" />
                <Column field="date" header="Date" />
                <Column field="time" header="Time" />
                <Column
                  field="amount"
                  header="Amount"
                  body={row => `$${row.amount}`}
                />
                <Column
                  header="View"
                  body={() => (
                     <Link
                          to={`/invoice-detail`}
                          className="btn btn-link btn-sm p-0"
                        >
                          View
                        </Link>
                  )}
                />
                <Column
                  header="Send Email"
                  body={() => (
                    <Button
                      icon="pi pi-envelope"
                      className="p-button-text p-button-sm"
                    />
                  )}
                />
                <Column
                  header="Paid"
                  body={row => (
                    <span
                      className={`badge ${
                        row.paid ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {row.paid ? "Yes" : "No"}
                    </span>
                  )}
                />
              </DataTable>
            </CardBody>
          </Card>

          {/* ================= PAYMENTS ================= */}
          <Card>
            <CardBody>
              <h5 className="mb-3">Payments</h5>

              <DataTable
                value={payments}
                responsiveLayout="scroll"
                emptyMessage="No payments found"
              >
                <Column field="date" header="Date" />
                <Column
                  field="amount"
                  header="Amount"
                  body={row => `$${row.amount}`}
                />
                <Column
                  field="stripeId"
                  header="Stripe Confirmation ID"
                />
              </DataTable>
            </CardBody>
          </Card>

        </Container>
      </div>
    </React.Fragment>
  );
};

ClientsSubscription.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(ClientsSubscription);
